<template>
  <div class="mainDirection">
    <!-- 导航栏 -->
    <div class="directions">
      <div v-for="(category, index) in visibleCategories" :key="index" @click="setActiveCategory(index)"
           :class="{'active': index === activeCategory, 'highlight': index === activeCategory}">
        <h3>{{ category.key }}</h3>
      </div>
      <div v-if="showMoreButton" @click="toggleMoreCategories" class="more-button" style="background-color: #444444">
        <h3>{{ showMore ? '收起' : '更多' }}</h3>
      </div>
    </div>


    <!-- 文章内容 -->
    <div class="articles">
      <div v-if="activeCategory !== null">
        <div
          class="grid-flex"
          :class="{ 'reverse': itemIndex % 2 !== 0 }"
          v-for="(item, itemIndex) in researchList[activeCategory].value"
          :key="itemIndex"
          @click.prevent="toBlog(item)"
        >
          <div class="col col-image">
            <img :src="item.firstPicture">
          </div>
          <div class="col col-text">
            <div class="Aligner-item">
              <h1 class="title">{{ item.title }}</h1>
              <p class="description" style="margin-top: 50px">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getResearchDirection} from "@/api";
import it from "element-ui/src/locale/lang/it";

export default {
  data() {
    return {
      researchDirection: '研发中心科研成果',
      researchList: [],
      activeCategory: null,
      showMore: false, // 是否展示更多项目
      maxVisibleCategories: 4 // 默认最多展示的项目数量
    };
  },
  methods: {
    getResearchDirection() {
      getResearchDirection(this.researchDirection).then(res => {
        if (res.code === 200) {
          this.researchList = this.objectToList(res.data);
          // 默认选择第一个分类
          if (this.researchList.length > 0) {
            this.activeCategory = 0;
          }
          console.log(res.data);
        }
      });
    },
    objectToList(obj) {
      const list = [];
      for (const [key, value] of Object.entries(obj)) {
        if (key !== '研发中心科研成果') { // 排除名字为“研发中心科研成果”的元素
          list.push({key, value});
        }
      }
      return list;
    },
    setActiveCategory(index) {
      this.activeCategory = index;
    },
    toBlog(blog) {
      console.log("1111111111111111111111111111111111");
      console.log(blog);
      this.$store.dispatch('goBlogPage', blog);
    },
    toggleMoreCategories() {
      this.showMore = !this.showMore;
    }
  },
  created() {
    this.getResearchDirection();
  },
  computed: {
    it() {
      return it;
    },
    visibleCategories() {
      if (this.showMore) {
        return this.researchList;
      } else {
        return this.researchList.slice(0, this.maxVisibleCategories);
      }
    },
    showMoreButton() {
      return this.researchList.length > this.maxVisibleCategories;
    }
  },
};
</script>

<style>
.mainDirection {
  width: 1400px;
}

.directions {
  position: fixed;
  width: 100%;
  left: 0;
  top: 50px;
  display: flex;
  justify-content: center; /* Horizontally centers the image */
  align-items: center;    /* Vertically centers the image */
  gap: 10px; /* 增加子元素之间的间距 */
  background-color: #444444;
}

.directions div {
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ddd;
}


.directions div {
  color: #FFFFFF; /* 高亮字体颜色为蓝色 */
}

.directions div.highlight {
  color: #20a0ff; /* 高亮字体颜色为蓝色 */
}

.more-button {
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f0f0f0;
  text-align: center;
}

.articles {
  margin-top: 70px;
}

.grid-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 50px;
  border-radius: 15px;
  box-shadow:
    -6px 0px 6px 0px #888888,  /* 左侧阴影 */
    6px 0px 6px 0px #888888;   /* 右侧阴影 */
}

.reverse {
  flex-direction: row-reverse;
}

.col {
  flex: 1;
}

.col.col-image {
  display: flex;
  justify-content: center; /* Horizontally centers the image */
  align-items: center;    /* Vertically centers the image */
  background-color: #FFFFFF;
  border-radius: 15px;
}

.col.col-image img{
  width: 30em;
  height: 20em;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;

}

.Aligner-item {
  width: 80%;
}

.Aligner-item p {
  font-size: 20px;
  line-height: 30px;
}

@media (max-width: 640px) {
  .grid-flex {
    height: 40em;
    flex-direction: column;
  }

  .col {
    order: vertical;
  }

  .col-text div p {
    padding: 1em;
    font-size: 20px;
  }

  .Aligner-item {
    width: 90%;
  }
}

</style>
